declare var angular: any;
declare var Papa: any;
import * as _ from 'underscore';

import { keyBy, get, sortBy, last } from 'lodash';

interface ScoreResult {
  email: string;
  displayName: string;
  score: any;
  hasStarted: boolean;
}

angular
  .module('TeacherControllers')

  .controller('TeacherExamHomeCtrl', [
    '$scope',
    '$mdDialog',
    'api',
    '$mdToast',
    'EXAM',
    function($scope, $mdDialog, api, $mdToast, EXAM) {
      console.log('🔥');

      api.getMySpheresSummary().then(function(data) {
        $scope.spheres = data;
        $scope.spheresById = _.indexBy(data, 'id');
      });

      api.getPlans().then(function(plans) {
        console.log(plans);
        $scope.plans = sortBy(plans, 'id').reverse();
      });

      api.getInstitutionProfiles('student', 'teacher').then(function(data) {
        $scope.studentsByUserId = keyBy(data.profiles, p => p.user.id);
      });

      $scope.showPlan = function(plan) {
        $scope.currentPlan = plan;
        $scope.currentExtendedPlan = {
          load: true,
          show: true
        };

        api
          .getPlan(plan.id, plan.sphere_id, plan.begin_date, plan.end_date)
          .then(function(data) {
            console.log(data);
            let results: ScoreResult[] = data.map(d => {
              let score = last(
                sortBy(
                  [
                    get(d, 'profile.user.results[0]'),
                    get(d, 'profile.user.profiles[0].answers[0].result')
                  ].filter(s => !!s),
                  'score'
                )
              );

              return {
                email: d?.profile?.user?.email,
                displayName: [
                  d?.profile?.user?.first_name,
                  d?.profile?.user?.last_name
                ].join(' '),
                score,
                hasStarted: !!get(d, 'profile.user.profiles[0].answers.length')
              };
            });
            $scope.currentExtendedPlan.data = results;
            $scope.currentExtendedPlan.load = false;
          });
      };

      $scope.closeShowPlan = function() {
        $scope.currentPlan = {};
        $scope.currentExtendedPlan = {
          load: false,
          show: false
        };
      };

      $scope.downloadCurrentExam = () => {
        let dataToConvert = $scope.currentExtendedPlan.data.map(
          (d: ScoreResult) => {
            let score = d?.score?.score;
            let data: any = {
              Email: d.email,
              Nom: d.displayName,
              Commencé: d.hasStarted,
              Score: d?.score?.score
            };

            if (EXAM === 'delf') {
              data = {
                ...data,
                listening_score:
                  d?.score?.listening_score !== null
                    ? `${d?.score?.listening_score}/25`
                    : 'Non corrigé',
                reading_score:
                  d?.score?.reading_score !== null
                    ? `${d?.score?.reading_score}/25`
                    : 'Non corrigé',
                oral_score:
                  d?.score?.oral_score !== null
                    ? `${d?.score?.oral_score}/25`
                    : 'Non corrigé',
                writing_score:
                  d?.score?.writing_score !== null
                    ? `${d?.score?.writing_score}/25`
                    : 'Non corrigé'
              };
            }

            if (EXAM === 'toeic') {
              data.listening_score = d?.score?.listening_score;
              data.reading_score = d?.score?.reading_score;
            }

            return data;
          }
        );

        let CSV = Papa.unparse(dataToConvert, { header: true });

        var BOM = '\uFEFF';
        var csvWithBom = BOM + CSV;
        var encodedUri =
          'data:text/csv;charset=utf-8,' + encodeURIComponent(csvWithBom);
        var link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'resultats.csv');
        document.body.appendChild(link);

        link.click();
      };

      $scope.newExamSession = function(ev) {
        $mdDialog
          .show({
            templateUrl:
              '/ng1/www/modules/teacher/exam/html/new_exam_session.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            preserveScope: true,
            parent: angular.element(document.body),
            controller: [
              '$scope',
              '$mdDialog',
              function DialogController($scope, $mdDialog) {
                api.getMySpheresSummary().then(function(data) {
                  $scope.spheres = data;
                });

                var addZero = function(number) {
                  if (number < 10) {
                    number = '0' + number;
                  }

                  return number;
                };

                var hours = [];
                var minutes = [];

                for (var i = 0; i < 60; i++) {
                  minutes.push(i);
                }

                for (var i = 0; i < 24; i++) {
                  hours.push(i);
                }

                var myDate = new Date();
                $scope.hours = hours;
                $scope.minutes = minutes;

                var currentMinutes = myDate.getMinutes();
                var currentHours = myDate.getHours();

                $scope.new = {
                  begin: {
                    minutes: currentMinutes,
                    hours: currentHours,
                    date: new Date()
                  },
                  end: {
                    minutes: currentMinutes,
                    hours: currentHours,
                    date: new Date()
                  }
                };

                $scope.hide = function() {
                  $mdDialog.hide();
                };

                $scope.cancel = function() {
                  $mdDialog.cancel();
                };

                $scope.submit = function() {
                  $scope.new.begin.date.setHours($scope.new.begin.hours);
                  $scope.new.begin.date.setMinutes($scope.new.begin.minutes);

                  $scope.new.end.date.setHours($scope.new.end.hours);
                  $scope.new.end.date.setMinutes($scope.new.end.minutes);

                  api
                    .createPlan(
                      $scope.selected,
                      $scope.new.begin.date,
                      $scope.new.end.date
                    )
                    .then(function(plan) {
                      $mdDialog.hide(plan);
                    });
                };
              }
            ]
          })
          .then(function(plan) {
            $scope.plans.push(plan);
            console.log(plan);
          });
      };

      $scope.deleteExamSession = function(plan, ev) {
        var confirm = $mdDialog
          .confirm({
            preserveScope: true,
            parent: angular.element(document.body)
          })
          .title('Êtes vous sur de vouloir supprimer ce ' + EXAM + ' ?')
          .textContent("L'historique des résultats ne sera plus disponible")
          .ariaLabel('Suppression de cet examen')
          .ok('Confirmer')
          .cancel('Annuler')
          .targetEvent(ev);

        $mdDialog.show(confirm).then(function() {
          api.deletePlan(plan.id).then(
            function(data) {
              console.log('Success');

              for (var i = 0; i < $scope.plans.length; i++) {
                if ($scope.plans[i].id == plan.id) {
                  $scope.plans.splice(i, 1);
                }
              }

              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent('Ce ' + EXAM + ' blanc a bien été supprimé')
                  .position('bottom right')
                  .hideDelay(3000)
              );
            },
            function(data) {
              console.log(data);
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent('Une erreur est survenue')
                  .position('bottom right')
                  .hideDelay(2000)
              );
            }
          );
        });
      };
    }
  ]);
